import { formatPrice } from '@scripts/frontend/libs/utils/format-price'
import { __ } from '@wordpress/i18n'

import type { Order } from '../libs/type'

export type OrderSummaryProps = Pick<
  Order,
  | 'discountTotal'
  | 'paymentMethodTitle'
  | 'shippingTax'
  | 'shippingTotal'
  | 'subTotal'
  | 'total'
  | 'totalTax'
>

function OrderSummary({
  discountTotal,
  paymentMethodTitle,
  shippingTax,
  shippingTotal,
  subTotal,
  total,
  totalTax,
}: Readonly<OrderSummaryProps>) {
  return (
    <div className="grid gap-4">
      <div className="flex justify-between">
        <label className="font-medium">{__('Subtotal', 'asavagroup')}:</label>
        <span>{formatPrice(subTotal)}</span>
      </div>
      {discountTotal > 0 && (
        <div className="flex justify-between">
          <label className="font-medium">{__('Discount', 'asavagroup')}:</label>
          <span className="text-red-600">-{formatPrice(discountTotal)}</span>
        </div>
      )}
      <div className="flex justify-between">
        <label className="font-medium">{__('Shipping', 'asavagroup')}:</label>
        {shippingTotal > 0 && <span>{formatPrice(shippingTotal)}</span>}
        {shippingTotal === 0 && (
          <span>{__('Free shipping', 'asavagroup')}</span>
        )}
      </div>
      <div className="flex justify-between">
        <label className="font-medium">
          {__('Payment method', 'asavagroup')}:
        </label>
        <span>{paymentMethodTitle}</span>
      </div>
      <div className="flex justify-between">
        <label className="font-medium">{__('Total', 'asavagroup')}:</label>
        <span>{formatPrice(total)}</span>
      </div>
    </div>
  )
}

export default OrderSummary
